import React from 'react';
import PropTypes from 'prop-types';

const defaultDimensions = {
  height: '232px',
  width: '100%',
};

const SoundCloudPlayer = ({
  episodeId,
  width = defaultDimensions.width,
  height = defaultDimensions.height,
  color = '',
}) => {
  const parseColor = (rawColor) => encodeURIComponent(rawColor);
  const src = `https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/${episodeId}&color=${parseColor(
    color
  )}&auto_play=false&hide_related=true&show_comments=false&show_user=false&show_reposts=false&show_teaser=false&visual=true`;

  if (!episodeId) {
    return null;
  }

  return (
    <iframe
      id="soundcloud-iframe"
      width={width || defaultDimensions.width}
      height={height || defaultDimensions.height}
      scrolling="no"
      frameBorder="no"
      src={src}
      title="Soundcloud podcast"
    />
  );
};

SoundCloudPlayer.propTypes = {
  episodeId: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  color: PropTypes.string,
};

SoundCloudPlayer.defaultProps = {
  episodeId: '',
  width: '',
  height: '',
  color: '#ff5500',
};

export default SoundCloudPlayer;
